import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const VendorPhoneInformation = () => {
    return (
        <div className="vendor-phone-information-wrapper">
            <div className="info-title">
                <h2 className="title">اطلاعات تماس</h2>
            </div>
            <div className="inputs-box">
                <div className="row">
                    <div className="col-xl-5 col-md-6">
                        <div className="select-input position-relative">
                            <select className="form-select input-personal-info">
                                <option value="default">استان</option>
                                <option>اصفهان</option>
                                <option>تهران</option>
                                <option>تهران</option>
                                <option>تهران</option>
                                <option>تهران</option>
                            </select>
                            <IconName name="expand_more" className="icon position-absolute more-icon"/>
                        </div>
                    </div>
                    <div className="col-xl-5 col-md-6">
                        <div className="select-input position-relative xmt-6 xmt-md-0">
                            <select className="form-select input-personal-info">
                                <option value="default">شهر</option>
                                <option>اصفهان</option>
                                <option>تهران</option>
                                <option>تهران</option>
                                <option>تهران</option>
                                <option>تهران</option>
                                <option>تهران</option>
                            </select>
                            <IconName name="expand_more" className="icon position-absolute more-icon"/>
                        </div>
                    </div>
                    <div className="col-xl-10 col-md-12">
                        <textarea placeholder="آدرس محل سکونت" className="input-personal-info xmt-6 xpy-3 xpx-6"/>
                    </div>
                    <div className="col-xl-5 col-md-6">
                        <input type="number" className="input-personal-info xmt-6" placeholder="کد پستی"/>
                    </div>
                    <div className="col-xl-5 col-md-6">
                        <input type="number" className="input-personal-info xmt-6" placeholder="تلفن همراه"/>
                    </div>
                    <div className="col-xl-5 col-md-6">
                        <div className="phone-input">
                            <input type="number" className="input-personal-info xmt-6" placeholder="تلفن ثابت"/>
                            <input type="number" className="input-personal-info xmt-6 phone-code-box"
                                   placeholder="کد شهر"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VendorPhoneInformation;
